<template>
  <div>
    <v-row class="pa-10">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
            image
          </v-icon>
          {{ $t('display/editor:title') }}
        </h2>
        <v-card elevation="0">
          <v-container>
            <v-row>
              <v-col md="3">
                <LeftPanel
                  ref="leftPanel"
                  @editorTextUpdate="(v) => {updateEditor(v);}"
                  @updateButtonText="(v) => {buttonText = v}"
                  @updateSide="(v) => {isLeft = v;}"
                  @updateType="(v) => {isButton = v;}"
                  @publishAdvert="collectAdvertData"
                  @saveAdvert="saveAdvert"
                />
              </v-col>
              <v-col md="9">
                <EditorPanel
                  ref="editorPanel"
                  :data="editorData"
                  :isButton="isButton"
                  :isLeft="isLeft"
                  :takenButtonText="buttonText"
                  @imageReady="publishAdvert"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LeftPanel from '@/modules/display/views/editor/form/LeftPanel';
import EditorPanel from '@/modules/display/views/editor/form/EditorPanel';
import EditorService from '@/modules/display/services/editor-service';
import Utils from '@/modules/core/services/utils';

export default {
  components: {
    LeftPanel,
    EditorPanel
  },
  name: 'EditorForm',
  data() {
    return {
      editorData: '',
      buttonText: this.$t('display/editor:editor-panel.insert-your-text'),
      isButton: true,
      isLeft: true,
      publishData: {}
    }
  },
  methods: {
    updateEditor(updateData) {
      this.editorData = updateData;
    },
    collectAdvertData() {
      this.publishData = Object.assign({},
        this.$refs.leftPanel.getPublishData(),
        this.$refs.editorPanel.getPublishData(),
      );

      this.$refs.editorPanel.generateImage();
    },
    publishAdvert(image) {
      this.publishData.base64ImageData = image;

      EditorService.publishAdvert(this.publishData,
        (response) => {
          this.$refs.leftPanel.updatePanel(response.data);
          Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:media')}));
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:media')}));
        }
      )
    },
    saveAdvert() {
      let saveData = Object.assign({},
        this.$refs.leftPanel.getPublishData(),
        this.$refs.editorPanel.getPublishData(),
      );

      let messageType = saveData.id ? 'edit' : 'add'
      EditorService.saveTemplate(saveData,
        (response) => {
          this.$refs.leftPanel.updatePanel(response.data);
          Utils.showSuccessSnackbar(this.$t(`snackbar:${messageType}-success`, {name: this.$t('display/editor:form.template')}));
        },
        () => {
          Utils.showFailureSnackbar(this.$t(`snackbar:${messageType}-failure`, {name: this.$t('display/editor:form.template')}));
        }
      )
    }
  },
  mounted() {
    this.$refs.editorPanel.reInitWysiwyg();
  }
}
</script>